
  import { Component, Mixins } from 'vue-property-decorator';
  import formModal from '@/mixins/formModal';

  @Component
  export default class FileModal extends Mixins(formModal) {
  }
